import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

interface AiConversationState {
    conversationId: string | null;
}

const initialState: AiConversationState = {
    conversationId: null,
};

export const aiConversationSlice = createSlice({
    name: 'aiConversation',
    initialState,
    reducers: {
        setAiConversationId: (state, action: PayloadAction<string>) => {
            state.conversationId = action.payload;
        },
        clearAiConversationId: (state) => {
            state.conversationId = null;
        },
    },
});

export const { setAiConversationId, clearAiConversationId } =
    aiConversationSlice.actions;

export const selectAiConversationId = (state: RootState) =>
    state.aiConversation.conversationId;

export const aiConversationReducer = aiConversationSlice.reducer;
